import { render, staticRenderFns } from "./LargeValuePaymentStep.vue?vue&type=template&id=255481b0&scoped=true"
import script from "./LargeValuePaymentStep.vue?vue&type=script&lang=js"
export * from "./LargeValuePaymentStep.vue?vue&type=script&lang=js"
import style0 from "./LargeValuePaymentStep.vue?vue&type=style&index=0&id=255481b0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "255481b0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/project/moneypay-web/moneypay-merchant-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('255481b0')) {
      api.createRecord('255481b0', component.options)
    } else {
      api.reload('255481b0', component.options)
    }
    module.hot.accept("./LargeValuePaymentStep.vue?vue&type=template&id=255481b0&scoped=true", function () {
      api.rerender('255481b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ezpay/online-transaction/components/LargeValuePaymentStep.vue"
export default component.exports